import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { auth } from '../../firebase/firebase'

const provider = new GoogleAuthProvider()

export default async function firebaseLoginGoogle() {
  return await signInWithPopup(auth, provider)
    .then(result => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result)
      const token = credential?.accessToken
      // The signed-in user info.
      const user = result.user
      // IdP data available using getAdditionalUserInfo(result)
      // ...
      return { user, token }
    })
    .catch(error => {
      console.log(error)
      // Handle Errors here.
      // const errorCode = error.code
      // const errorMessage = error.message
      // The email of the user's account used.
      // const email = error.customData.email
      // The AuthCredential type that was used.
      // const credential = GoogleAuthProvider.credentialFromError(error)
      // ...
    })
}
